import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll manager for the whole app (Lenis-aware):
 * - Route WITH a `#anchor` hash  → smooth-glide to that section once mounted
 *   (e.g. /#team lands on the Our Work section of the Home page).
 * - Route WITHOUT a hash → always reset to the very top of the page, so
 *   category and project pages never retain a previous scroll position.
 */
export default function HashScrollHandler() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const lenis = window.__lenis;
    if (!hash) {
      if (lenis) lenis.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
      return;
    }
    const id = hash.slice(1);
    // Wait a beat for the target route to render
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (!el) return;
      if (window.__lenis) window.__lenis.scrollTo(el);
      else el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
}
